// extracted by mini-css-extract-plugin
module.exports = {"OrderInfo":"OrderLink_OrderInfo__eS3OX","UploadInfo":"OrderLink_UploadInfo__9J2zs"};